import { useEffect } from "react";

/** Shared route/history guard; closing a child editor need not discard its parent draft. */
export function useDraftLeaveGuard({ dirty, busy, routeDirty = dirty, message = "저장하지 않은 변경이 있습니다. 변경을 버리고 나가시겠습니까?" }: { dirty: boolean; busy: boolean; routeDirty?: boolean; message?: string }) {
  const canClose = () => !busy && (!dirty || window.confirm(message));
  useEffect(() => {
    if (!routeDirty && !busy) return;
    const leave = (event: Event) => { if (event.defaultPrevented) return; if (busy || routeDirty && !window.confirm(message)) event.preventDefault(); };
    const unload = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("planner-settings-leave", leave); window.addEventListener("beforeunload", unload);
    return () => { window.removeEventListener("planner-settings-leave", leave); window.removeEventListener("beforeunload", unload); };
  }, [routeDirty, busy, message]);
  return canClose;
}
